type ZoneProjectsRetrievalFilter = {
  start: number;
  limit: number;
  creationDate: string;
  isSortedByJoinedProject: boolean;
  isOpen: boolean;
  isSortedAlphabetically: boolean;
};

const zoneProjectsRetrievalFilter: ZoneProjectsRetrievalFilter = {
  start: 0,
  limit: 0,
  creationDate: "",
  isSortedByJoinedProject: false,
  isOpen: false,
  isSortedAlphabetically: false,
};

export type { ZoneProjectsRetrievalFilter };

export { zoneProjectsRetrievalFilter };
